import React from "react";
import Typography from "components/Typography";
import { tickDarkGreenIcon, closeIcon } from "components/Icon";
import { StringItem } from "components/StringItem";
import { BOOLEAN_VALUES } from "../../constants";
import classes from "./GoodsamInsuranceMobileTableTds.module.css";
import cn from 'classnames';

export const GoodsamInsuranceMobileTableTds = (props) => {
  const {
    groupData,
    planData
  } = props;

  const { header = null, value: groupValue } = groupData;
  const { value: planValue } = planData;

  return (
    <div className={classes.container}>
      <div className={classes.column}>
        {header ? (
          <Typography
            variant="body"
            size="s"
            className={classes.header}
          >
            {header}
          </Typography>
        ) : null}

        {groupValue ?  (
          <StringItem
            data={groupValue}
            headerStyle={classes.header}
            headerProps={{
              variant: "body",
              size: "s"
            }}
            textStyle={classes.value}
            textProps={{
              variant: "body",
              size: "s"
            }}
          />
        ) : null}
      </div>
      <div className={cn(classes.column, classes.planColumn)}>
        {planValue?.value === BOOLEAN_VALUES.TRUE ? <div className={cn(classes.iconContainer, classes.trueIcon)}>{tickDarkGreenIcon}</div> : null}
        {planValue?.value === BOOLEAN_VALUES.FALSE ? <div className={cn(classes.iconContainer, classes.falseIcon)}>{closeIcon}</div> : null}

        {planValue?.value && planValue?.value !== BOOLEAN_VALUES.TRUE && planValue?.value !== BOOLEAN_VALUES.FALSE && !header ? (
          <StringItem
            data={planValue}
            headerStyle={classes.header}
            headerProps={{
              variant: "body",
              size: "s"
            }}
            textStyle={classes.value}
            textProps={{
              variant: "body",
              size: "s"
            }}
          />
        ) : null}
      </div>
    </div>
  );
};
